import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ui } from '@/constants';
import { CountryCode } from '@/store/ui';
import { isLoyaltyEnabled } from '@/helpers';

@Component({
  name: 'CmgNoLoyaltyForYouModal',
})
export default class CmgNoLoyaltyForYouModal extends Vue {

  get visible(): boolean {
    return this.$appStore.state.ui.modals.noLoyaltyForYou.visible;
  }

  get logoUrl(): string {
    return this.$appStore.state.cms.images.logos.medallion.default;
  }

  get siteCountryCode(): string {
    return this.$appStore.state.ui.countryProfile.countryCode;
  } 

  get isLoyaltyEnabled(): boolean {
    return isLoyaltyEnabled(this.siteCountryCode);
  }

  get rewardsTermsUrl(): string {
    return this.$services.config.getRewardsTermsUrl();
  }

  get rewardsText() {
    let rewardsSubheading = '';

    switch (this.siteCountryCode) {
      case CountryCode.CA:
        rewardsSubheading = `The program hasn't made its way up north just yet. Stay tuned and we'll let you know when it's ready in Canada.`;
        break;
      case CountryCode.GB:
        rewardsSubheading = `The program hasn't made its way over yet. Stay tuned and we'll let you know when it's ready in U.K.`;
        break;
      default:
        rewardsSubheading = ``;
    }

    return rewardsSubheading;
  }

  get faqUrl(): string {
    return this.$services.config.getFaqUrl();
  }

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneLgMax;
  }
  
  close(): void {
    this.$services.ui.setModalVisibility('noLoyaltyForYou', false);
  }
}
